module.exports = __webpack_public_path__ + "img/comodin-pistas.845ccf14.png";